/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type ItemPreviews_item$ref = any;
type ListRow_item$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type Tiles_portfolioItemsConnection$ref: FragmentReference;
export type Tiles_portfolioItemsConnection = {|
  +edges: ?$ReadOnlyArray<?{|
    +node: ?{|
      +portfolioItemId: ?string,
      +note: ?string,
      +item: ?{|
        +id: string,
        +serviceId: ?string,
        +title: ?string,
        +firstPhotoWebPath: ?string,
        +contemporaryTrackingString: string,
        +categoryPath: ?string,
        +seller: ?{|
          +serviceId: ?string
        |},
        +pricing: ?{|
          +retailPrice: ?{|
            +amount: ?number
          |}
        |},
        +tilesProjects?: ?$ReadOnlyArray<?{|
          +name: ?string,
          +serviceId: ?string,
        |}>,
        +$fragmentRefs: ListRow_item$ref & ItemPreviews_item$ref,
      |},
    |}
  |}>,
  +$refType: Tiles_portfolioItemsConnection$ref,
|};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "serviceId",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "Tiles_portfolioItemsConnection",
  "type": "PortfolioItemsConnection",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "userId",
      "type": "String!"
    },
    {
      "kind": "RootArgument",
      "name": "hasUserId",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "PortfolioItemsEdge",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "PortfolioItemV2",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "portfolioItemId",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "note",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "item",
              "storageKey": null,
              "args": null,
              "concreteType": "Item",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "categoryPath",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "id",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "title",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "firstPhotoWebPath",
                  "args": [
                    {
                      "kind": "Literal",
                      "name": "size",
                      "value": "large",
                      "type": "ImageVersionTypeName!"
                    }
                  ],
                  "storageKey": "firstPhotoWebPath(size:\"large\")"
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "contemporaryTrackingString",
                  "args": null,
                  "storageKey": null
                },
                (v0/*: any*/),
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "seller",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "Seller",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/)
                  ]
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "pricing",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "ItemPricing",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "retailPrice",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "FinancialAmount",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "ScalarField",
                          "alias": null,
                          "name": "amount",
                          "args": null,
                          "storageKey": null
                        }
                      ]
                    }
                  ]
                },
                {
                  "kind": "FragmentSpread",
                  "name": "ListRow_item",
                  "args": null
                },
                {
                  "kind": "FragmentSpread",
                  "name": "ItemPreviews_item",
                  "args": null
                },
                {
                  "kind": "Condition",
                  "passingValue": true,
                  "condition": "hasUserId",
                  "selections": [
                    {
                      "kind": "LinkedField",
                      "alias": "tilesProjects",
                      "name": "projects",
                      "storageKey": null,
                      "args": [
                        {
                          "kind": "Variable",
                          "name": "userId",
                          "variableName": "userId",
                          "type": "String!"
                        }
                      ],
                      "concreteType": "Project",
                      "plural": true,
                      "selections": [
                        {
                          "kind": "ScalarField",
                          "alias": null,
                          "name": "name",
                          "args": null,
                          "storageKey": null
                        },
                        (v0/*: any*/)
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = '39e6c9ba6f7025c33e64d8f995c6b246';
module.exports = node;
